<svg width="343" height="342" viewBox="0 0 343 342" fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <mask id="mask0_79_4788" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="343" height="342">
    <path d="M0.386719 0.0663452H342.254V341.934H0.386719V0.0663452Z" fill="white"/>
  </mask>
  <g mask="url(#mask0_79_4788)">
    <mask id="mask1_79_4788" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="343" height="342">
      <path d="M171.32 0.0663452C265.724 0.0663452 342.254 76.5961 342.254 171C342.254 265.404 265.724 341.934 171.32 341.934C76.9164 341.934 0.386719 265.404 0.386719 171C0.386719 76.5961 76.9164 0.0663452 171.32 0.0663452V34.2523C95.7976 34.2523 34.5727 95.4772 34.5727 171C34.5727 246.523 95.7976 307.748 171.32 307.748C246.843 307.748 308.068 246.523 308.068 171C308.068 95.4772 246.843 34.2523 171.32 34.2523V0.0663452Z" fill="white"/>
    </mask>
    <g mask="url(#mask1_79_4788)">
      <path d="M0.386719 0.0663452H342.254V341.934H0.386719V0.0663452Z" fill="#FEEB73"/>
    </g>
  </g>
  <mask id="mask0_79_4797" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="325" height="343">
    <path d="M0.234375 0.629639H324.679V342.358H0.234375V0.629639Z" fill="white"/>
  </mask>
  <g mask="url(#mask0_79_4797)" transform="translate(18,0)">
    <mask id="mask1_79_4797" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="1" width="325" height="341">
      <path d="M172.315 1.12346C253.131 10.159 316.394 74.8812 323.586 155.884C330.777 236.885 279.907 311.741 201.944 334.873C123.983 358.004 40.5187 323.01 2.3667 251.195C-2.06231 242.858 1.10513 232.509 9.44232 228.079C17.7795 223.65 28.1287 226.818 32.5577 235.155C63.0785 292.609 129.851 320.605 192.22 302.098C254.589 283.593 295.287 223.708 289.533 158.907C283.781 94.1057 233.169 42.3272 168.516 35.0992C162.446 34.4201 157.201 30.5563 154.753 24.9603C152.307 19.3661 153.03 12.8904 156.653 7.97338C160.276 3.05633 166.246 0.446376 172.315 1.12346Z" fill="white"/>
    </mask>
    <g>
      <g mask="url(#mask1_79_4797)">
        <path d="M-17.6113 0.0663452H324.256V341.934H-17.6113V0.0663452Z" fill="#2E5394"/>
      </g>
    </g>
  </g>
</svg>
